import React from 'react'

const ResponseMsg = ({message}) => {
  return (
    <>
      <div className='response-area py-2 px-2 animate__animated animate__slideInDown'>
        <p className='my-0 px-4 py-1'>{message}</p>
      </div>
    </>
  )
}

export default ResponseMsg
